"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toolbar = function Toolbar(props) {
  var count = props.count,
      currentPage = props.currentPage,
      label = props.label,
      perPage = props.perPage;


  var start = perPage * (currentPage - 1) + 1;
  var rawEnd = perPage * currentPage;
  var end = rawEnd > count ? count : rawEnd;

  var content = null;
  if (end) {
    content = _react2.default.createElement(
      "div",
      { className: "erg-components-Toolbar erg-table-count" },
      _react2.default.createElement(
        "strong",
        null,
        start
      ),
      " to ",
      _react2.default.createElement(
        "strong",
        null,
        end
      ),
      " out of ",
      _react2.default.createElement(
        "strong",
        null,
        count
      ),
      " ",
      label,
      "."
    );
  }

  return content;
};

Toolbar.displayName = "Toolbar";

Toolbar.propTypes = {
  count: _propTypes2.default.number.isRequired,
  currentPage: _propTypes2.default.number.isRequired,
  label: _propTypes2.default.string.isRequired,
  perPage: _propTypes2.default.number.isRequired
};

exports.default = Toolbar;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/table/Toolbar.js
 ** module id = 800
 ** module chunks = 0
 **/